<!-- @Description 产品架构 -->
<template>
  <div class="product-architecture">
    <!-- <div class="info">
      <div class="title">产品架构</div>
      <div class="content">
        华院计算以认知智能算法平台为底座，向上构建工业级智能体与运营决策智能体等应用层能力，形成「平台 + 智能体」的分层产品架构。平台层提供算法引擎、知识构建与可信推理能力；应用层面向制造、运营、财务等业务场景，提供可落地的智能化产品与解决方案。
      </div>
    </div> -->
    <div class="architecture">
      <div class="title">架构总览</div>
      <div class="arch-layout">
        <div
          class="arch-layer"
          v-for="item in layers"
          :key="item.key"
        >
          <img :src="item.img" :alt="item.alt" class="arch-layer-img" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import imgAgent from "@/../static/img/productArchitecture/应用层智能体.png";
import imgPlatform from "@/../static/img/productArchitecture/认知智能算法平台.png";
export default {
  name: "product-architecture",
  data() {
    return {
      layers: [
        {
          key: "agent",
          img: imgAgent,
          alt: "应用层智能体"
        },
        {
          key: "platform",
          img: imgPlatform,
          alt: "认知智能算法平台"
        }
      ]
    };
  },
  computed: {
  },
  methods: {
  }
};
</script>
<style lang="less" scoped>
.product-architecture {
  width: 100%;
  padding: 96px 0 64px;
  height: calc(100vh - 636px);
  .info {
    width: 100%;
    height: 632px;
    background: url("../../../../static/img/product/product_digitization_bg.png")
      no-repeat 0 0 / 100%;
    overflow: hidden;
    .title {
      margin-top: 48px;
      font-size: 44px;
      font-weight: 500;
      color: #08204d;
      line-height: 60px;
      text-align: center;
    }
    .content {
      padding: 0 68px;
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      margin-top: 24px;
    }
  }
  .architecture {
    .title {
      font-size: 40px;
      color: #08204d;
      line-height: 56px;
      text-align: center;
      margin-top: 44px;
      margin-bottom: 44px;
      font-weight: 500;
    }
    .arch-layout {
      padding: 24px 64px 0;
    }
    .arch-layer {
      margin-top: 20px;
      cursor: pointer;
      &:first-child {
        margin-top: 0;
      }
    }
    .arch-layer-img {
      width: 100%;
      display: block;
    }
    .arch-tip {
      margin-top: 16px;
      font-size: 22px;
      color: #97a2b5;
      line-height: 52px;
      text-align: center;
    }
  }
  .preview-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease;
    &.preview-mask-active {
      opacity: 1;
      visibility: visible;
    }
  }
  .preview-close {
    position: absolute;
    top: 120px;
    right: 48px;
    width: 48px;
    height: 48px;
    font-size: 40px;
    color: #ffffff;
    line-height: 48px;
    text-align: center;
    cursor: pointer;
  }
  .preview-img {
    width: calc(100% - 128px);
    max-height: calc(100vh - 160px);
    object-fit: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/productArchitecture/index.vue